import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ngx-doc-form-textarea',
  templateUrl: './doc-form-textarea.component.html',
  styleUrls: ['./doc-form-textarea.component.scss'],
})
export class DocFormTextareaComponent implements OnInit {

  @Input() title: string;
  @Input() value: string;
  @Input() rows: string | number;
  @Input() placeholder: string;
  @Input() disabled: boolean = false;
  @Output() valueChange: EventEmitter<string>;

  constructor() {
    this.valueChange = new EventEmitter<string>();
  }

  ngOnInit() {
  }

  updateValue(event) {
    this.valueChange.emit(event);
  }
}
